'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$filter", function ($filter) {
    return function (input, limit) {
        if (!util.isDefined(input)) {
            return;
        } else if (input.length <= limit) {
            return input;
        }

        return $filter('limitTo')(input, limit) + '...';
    };
}];
